module.exports = __webpack_public_path__ + "static/img/05046C_1_C_20210308_fit.c8ad80e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05046C_1_C_20210308_fit.png
// module id = eyV7
// module chunks = 0